module.exports = __webpack_public_path__ + "img/superscript.759f4caf.svg";